export default "__VITE_ASSET__CbQC$zKa__"